import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';

/**
 * 검색 사전 (AMZUWEB-694 · 백엔드 AMZBM-113).
 *
 * 🔴 「검색 키워드」 와 **별도 상위 줄**로 둔다. 같은 묶음에 넣으면 상위 「검색 키워드」 를 체크하는 순간
 *    검색 사전의 등록·수정·삭제까지 함께 켜진다(상위 체크는 PERMISSIONS_MAP 의 subject 를 전부 켠다).
 *    동의어는 저장 즉시 고객 검색 결과가 바뀌어 따로 부여해야 하는 권한이다.
 */
export const SEARCH_DICTIONARY_MENU: PermissionTableRowType = {
  name: '검색 사전',
  key: 'SEARCH_DICTIONARY_MANAGE',
  subRows: [
    {
      // AMZUWEB-694 — 동의어는 저장 즉시 고객 검색에 반영돼 검색 키워드와 분리한 전용 권한
      name: '검색 사전',
      key: PERMISSION_SUBJECTS.SEARCH_DICTIONARY,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DELETE,
      ],
      subRows: [
        {
          name: '동의어 목록 조회',
          key: PERMISSION_SUBJECTS.SEARCH_DICTIONARY,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '동의어 상세 · 미리보기 · 이력 · 사용자사전 조회',
          key: PERMISSION_SUBJECTS.SEARCH_DICTIONARY,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '동의어 등록',
          key: PERMISSION_SUBJECTS.SEARCH_DICTIONARY,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '동의어 수정',
          key: PERMISSION_SUBJECTS.SEARCH_DICTIONARY,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '동의어 삭제',
          key: PERMISSION_SUBJECTS.SEARCH_DICTIONARY,
          permissions: [PERMISSION_ACTIONS.DELETE],
        },
      ],
    },
  ],
};
